import { isMobileApp } from 'webui/utils/version';
export function copy2Clipboard(value) {
    if (isMobileApp()) {
        window.cordova.plugins.clipboard.copy(value, console.log, console.error);
        return;
    }
    if (navigator.clipboard != null) {
        navigator.clipboard.writeText(value + '').then();
        return;
    }
    //use for mobile-browser, like chrome
    const input = document.createElement('textarea');
    input.innerHTML = value;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
}
export function getDropdownCustomIcons(icons) {
    return icons
        .slice()
        .sort((a, b) => a.title[0] < b.title[0] ? -1 : a.title[0] > b.title[0] ? 1 : 0)
        .map((icon) => ({
        value: icon.id,
        text: icon.title[0],
        Icon: icon.render,
    }));
}
